var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ1DownRightArrowB(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 39v17H39l7.07-7.07L20 22.83 22.83 20l26.1 26.1L56 39z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J1_Down_right_arrow_B.d27287fa.svg";
export { SvgJ1DownRightArrowB as ReactComponent };